/**
 * Actions stores the transactions shown in the dashboard
 * page
 */

import {
  baseGetters,
  baseMutations,
  createBaseActions,
  createBaseState
} from '@/store/modules/entries/base'

import { expenseActions } from './expenses'
import { incomeActions } from './incomes'

const baseActions = createBaseActions({
  entryType: 'dashboard/actions',
  hasStatuses: false
})

const initActionState = () => ({
  ...createBaseState()
})

const actionMutations = {
  ...baseMutations,
  clearAllData: (state) => {
    Object.assign(state, createBaseState())
  }
}

const actionGetters = {
  ...baseGetters
}

const actionActions = {
  ...baseActions,
  markAsPaid(context, { id, type, payload }) {
    const entry = context.getters.getEntry(id)

    if (type === 'income') {
      return incomeActions.markAsPaid(context, { id, entry, payload })
    }
    return expenseActions.markAsPaid(context, { id, entry, payload })
  },
  toResend({ dispatch }, { id }) {
    return dispatch('incomes/toResend', { id }, { root: true })
  }
}

export const actionModule = {
  namespaced: true,
  state: initActionState,
  getters: actionGetters,
  mutations: actionMutations,
  actions: actionActions
}

export default actionModule
